/* finance: перевод строк финансов Zoho Books (finance.tsx, finance-api.ts) — блок «Финансы Books» в карточках компании, контакта и сделки, право «Финансы всех клиентов». Ключ — русская строка как в коде. */
const d: Record<string, string> = {
  "на утверждении": "pending approval",
  "утверждён": "approved",
  "Оплата {n}": "Payment {n}",
  "Кредит-нота {n}": "Credit note {n}",
  "Счета": "Invoices",
  "Оплаты": "Payments",
  "Заказы": "Orders",
  "Кредит-ноты": "Credit notes",
  "Финансы Books": "Books finance",
  "Финансы этого клиента видят его продавец и сотрудники с правом «Финансы всех клиентов».": "This client's finances are visible to their salesperson and to staff with the “All clients' finance” permission.",
  "Не удалось загрузить финансы.": "Could not load finance data.",
  "Выручка (счета)": "Revenue (invoices)",
  "за 12 мес {sum}": "last 12 months {sum}",
  "просрочено {sum} · {d}": "overdue {sum} · {d}",
  "{n} счетов к оплате": "{n} invoices due",
  "Средний чек": "Average invoice",
  "Последняя оплата": "Last payment",
  "платят в среднем за {d}": "pays in {d} on average",
  "последний заказ {date}": "last order {date}",
  "Не связан с клиентом Zoho Books — связать можно в разделе «Zoho».": "Not linked to a Zoho Books customer — link it in the “Zoho” section.",
  "обновляется каждые 15 минут": "refreshed every 15 minutes",
  "Документов нет.": "No documents.",
  "Показаны последние {n} документов; остальные — в Zoho Books.": "Showing the latest {n} documents; the rest are in Zoho Books.",
  "оплачено {sum}": "paid {sum}",
  "Финансы всех клиентов": "All clients' finance",
  "Видит выручку, долг и оплаты Zoho Books у любого клиента. Без права — только у своих клиентов.": "Can see Zoho Books revenue, outstanding balance and payments of any client. Without it — only of their own clients.",
  // ── раздел «Финансы» (finance-section.tsx, site.json, app-catalog.ts) ──
  "Финансы": "Finance",
  "Дебиторка Books": "Books receivables",
  "Финансы — кто и сколько должен": "Finance — who owes what",
  "Дебиторка по клиентам Zoho Books: долг, просрочка и её срок, старение долга, последняя оплата, продавец. Строка раскрывается в счета и оплаты клиента; из диалога видно новый счёт и поступившую оплату.": "Receivables by Zoho Books customer: outstanding balance, overdue amount and age, ageing of debt, last payment, salesperson. A row expands into the customer's invoices and payments; new invoices and incoming payments show up in the conversation.",
  "В срок": "Not yet due",
  "1–30 дн.": "1–30 days",
  "31–60 дн.": "31–60 days",
  "61–90 дн.": "61–90 days",
  "90+ дн.": "90+ days",
  "Долг всего": "Total outstanding",
  "{n} открытых счетов": "{n} open invoices",
  "Просрочено": "Overdue",
  "{p}% долга": "{p}% of outstanding",
  "Клиентов с долгом": "Customers with balance",
  "с просрочкой — {n}": "overdue — {n}",
  "На дату": "As of",
  "зеркало Books, каждые 15 минут": "Books mirror, every 15 minutes",
  "Старение долга": "Ageing of debt",
  "Клиент или продавец": "Customer or salesperson",
  "Поиск по дебиторке": "Search receivables",
  "Продавец": "Salesperson",
  "Все продавцы": "All salespeople",
  "Только просроченные": "Overdue only",
  "Только мои клиенты": "My customers only",
  "Показаны только ваши клиенты": "Only your customers are shown",
  "{n} клиентов": "{n} customers",
  "Клиент": "Customer",
  "Счетов": "Invoices",
  "Долг": "Outstanding",
  "Самый старый срок": "Oldest due date",
  "Долгов нет.": "No outstanding balances.",
  "Долг — остаток по счетам Zoho Books без черновиков и аннулированных; просрочка — по сроку оплаты счёта. Клиенты, не связанные с компанией или контактом Hub, открываются в Books.": "Outstanding — the balance of Zoho Books invoices excluding drafts and voided ones; overdue — by the invoice due date. Customers not linked to a Hub company or contact open in Books.",
  "открыть в Books": "open in Books",
  // события в диалоге (inboxapp-pane.tsx)
  "Выставлен счёт {n} на {sum}": "Invoice {n} issued for {sum}",
  "Получена оплата {sum} по счёту {n}": "Payment {sum} received for invoice {n}",
  "Получена оплата {sum}": "Payment {sum} received",
};
export default d;
